// 二级品牌馆配置 畅游
export default {
  'cy.ubanquan.cn': {
    // 主应用二级品牌馆id映射
    development: {
      storeNo: 'ST788800000100001669371739',
      storeName: '畅由生态馆',
      microHost: 'test-cy.ubanquan.cn'
    },
    test: {
      storeNo: 'ST788800000100001669371739',
      storeName: '畅由生态馆',
      microHost: 'test-cy.ubanquan.cn'
    },
    realpre: {
      storeNo: 'ST788800000100001669371739',
      storeName: '畅由生态馆',
      microHost: 'cy-brand.ubanquan.cn'
    },
    production: {
      storeNo: 'ST788800000100001669371739',
      storeName: '畅由生态馆',
      microHost: 'cy-brand.ubanquan.cn'
    }
  }
};